import React from "react";
import "./Footer.css";
import LsbLogo from "../Assets/lsbLogo.png";
import Facebook from "./facebook.png";
import Twitter from "./Xtwitter.png";
import LinkedIn from "./linkedin.png";
import { NavLink } from "react-router-dom";

function Footer() {
  const CurrentYear = () => {
    const year = new Date().getFullYear();
    return <span>{year}</span>;
  };

  return (
    <footer className="footer-section bg-black rounded-t-3xl">
      <div className="px-8">
        {/* contact details */}
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8 pt-4">
          {[
            { icon: "fas fa-phone", title: "Call us", content: "+254 799 093 219" },
            { icon: "fas fa-map-marker-alt", title: "Find us", content: "Land Surveyors Board, Survey of Kenya Headquarters, P.O. Box 30046-00100, Ruaraka Nairobi- Kenya" },
            { icon: "far fa-envelope", title: "Mail us", content: "info@lsb.go.ke" }
          ].map((item, index) => (
            <div key={index} className="flex flex-col gap-1 items-center text-center cursor-pointer">
              {item.icon === "fas fa-map-marker-alt" ? (
                <NavLink exact to="/contact"><i className={`${item.icon} text-[#ebcab3] fa-2x hover:text-white`}></i></NavLink>
              ) : (
                <i className={`${item.icon} text-[#ebcab3] fa-2x hover:text-white`}></i>
              )}
              <div>
                <p className="text-white fw-bold">{item.title}</p>
                <p className="text-white">{item.content}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white h-0.5 my-4"></div>

        {/* footer summary */}
        <div className="footer-content pt-2 pb-3">
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-8">
            <div className="flex flex-col justify-center">
              <div className="footer-widget">
                <div className="flex justify-center items-center my-3">
                  <a href="/">
                    <img src={LsbLogo} className="img-fluid" alt="logo" style={{ width: 'calc(13em + 2vw)' }} />
                  </a>
                </div>

                <div className="text-center mx-4">
                  <p className="text-gray-200 leading-6">
                    The Land Surveyors' Board was founded in 1923 and operates
                    under the authority of the Survey Act Cap 299 of the Laws
                    of Kenya. We regulate land surveyors practice to ensure
                    professionalism and uphold industry standards within the
                    Republic of Kenya.
                  </p>
                </div>

                <div className="flex flex-col justify-center items-center gap-3 mx-3">
                  <span className="text-white">Engage with us on:</span>

                  <div className="flex gap-3">
                    <a href="https://www.facebook.com/profile.php?id=61558428002052" target="_blank" rel="noreferrer" className="text-white">
                      <img alt="linkedIn" src={Facebook} className="hover:scale-110 rounded-full p-1 bg-[#ffffff] hover:bg-[#ebcab3]" />
                    </a>

                    <a href="https://twitter.com/kenya_lsb" target="_blank" rel="noreferrer" className="text-white">
                      <img alt="linkedIn" src={Twitter} className="hover:scale-110 rounded-full p-1 bg-[#ffffff] hover:bg-[#ebcab3]" />
                    </a>

                    <a href="https://www.linkedin.com/company/land-surveyors-board-ken" target="_blank" rel="noreferrer" className="text-white">
                      <img alt="linkedIn" src={LinkedIn} className="hover:scale-110 rounded-full p-1 bg-[#ffffff] hover:bg-[#ebcab3]" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="footer-widget">
                <h4 className="text-white font-bold uppercase underline underline-offset-4">Useful Links</h4>

                <div className="flex flex-col">
                  <a
                    href="https://ardhisasa.lands.go.ke/home"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> Ardhisasa
                  </a>

                  <a
                    href="https://lands.go.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> State Department for Lands & Physical Planning
                  </a>

                  <a
                    href="https://isk.or.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    Institution of Surveyors of Kenya
                  </a>

                  <a
                    href="https://www.allsk.co.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> Association of Licensed Land Surveyors of Kenya (ALLSK)
                  </a>

                  <a
                    href="https://kism.ac.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> Kenya Institute of Surveying & Mapping
                  </a>

                  <a
                    href="https://accounts.ecitizen.go.ke/en"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}  
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> E-CITIZEN
                  </a>

                  <a
                    href="https://landcommission.go.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> National Land Commission
                  </a>

                  <a
                    href="https://pprb.or.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> Physical Planners Registration Board (PPRB)
                  </a>

                  <a
                    href="https://vrb.or.ke/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-gray-300 text-decoration-none hover:text-[#ebcab3] font-medium" style={{ fontSize: '0.95rem' }}
                  >
                    <span className="w-2 h-2 bg-[#ebcab3] inline-block mr-2"></span> Valuers Registration Board (VRB)
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h4 className="text-white fw-bold underline underline-offset-4 uppercase">Subscribe</h4>
                </div>

                <div className="footer-text mb-25">
                  <p className="text-gray-300">
                    Don&apos;t miss to subscribe to our new feeds.
                  </p>
                </div>

                <div className="">
                  <form action="/" className="flex">
                    <input
                      type="text"
                      placeholder="Email Address"
                      className="p-2"
                    />
                    <button className="rounded-r-lg bg-[#ebcab3] px-4">
                      <i class="fa-solid fa-envelope text-[#3d0707]"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* footer navigation */}
      <div className="flex flex-col justify-center items-center pt-5 py-3 bg-gray-700">
        {(() => {
          const footerLinks = [
            { href: "/", label: "Home" },
            { href: "/about", label: "About" },
            { href: "/register", label: "Register" },
            { href: "/resources", label: "Resources" },
            { href: "/contact", label: "Contact" },
            { href: "/privacy", label: "Privacy" },
          ];
          return (
            <div className="flex flex-wrap justify-center gap-3">
              {footerLinks.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  className="relative overflow-hidden text-decoration-none text-white font-medium transition-all duration-300 ease-[cubic-bezier(.6,-0.28,.74,.05)] group"
                  style={{ display: "inline-block" }}
                >
                  <span
                    className="relative z-10 transition-colors duration-300 ease-in-out group-hover:text-[#ebcab3] group-hover:font-bold"
                  >
                    {link.label}
                  </span>
                  <span
                    className="absolute left-0 bottom-0 w-full h-[3px] bg-[#ebcab3] opacity-0 group-hover:opacity-100 scale-x-0 group-hover:scale-x-100 transform transition-all duration-300 origin-left"
                  ></span>
                </a>

              ))}
            </div>
          );
        })()}

        <div className="flex justify-center w-full py-2">
          <div
            className="relative h-[3px] w-[70vw] bg-gradient-to-r from-[#ebcab3]/0 via-[#ebcab3] to-[#ebcab3]/0 rounded-full shadow-md"
            style={{
              marginTop: "0.6rem",
              marginBottom: "0.6rem",
              boxShadow: "0 1px 10px 0 #ebcab3b0, 0 2px 8px -4px #ebcab370",
            }}
          >
          </div>
        </div>


        <div className="mt-2 flex flex-col justify-center items-center leading-4">
          <span className="text-white font-light flex">Copyright &copy; <CurrentYear /></span>

          <small className="text-white font-medium pt-2">
            Built & maintained by: <b className="text-[#ebcab3] underline underline-offset-4">SOK Developers Team</b>
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
